import type { TMessages } from '@/types/TMessages'

export const messages = {
  form: { title: 'Подайте заявку на кредит  от ВТБ уже сейчас!' },
  header: {
    button: 'Подать заявку на кредит',
    title: 'Инвестиционный кредит',
    description: 'Кредит для приобретения земли и имущества, строительства недвижимости или финансирования комплексных проектов.',
  },
  steps: {
    '1': 'Оформление заявки<br/>и Консультация с менеджером',
    '2': 'Подготовка документов',
    '3': 'Оценка<br/>залога',
    '4': 'Анализ<br/>и одобрение',
    '5': 'Подписание<br/>документов и получение средств',
    button: 'Подать заявку',
    title: 'Этапы получения средств',
  },
  affiliation: {
    description:
      '<ul class="list-with-marks"><li>Индивидуальный предприниматель;</li><li>Индивидуальный предприниматель – глава крестьянско-фермерского  хозяйства;</li><li>Общество с ограниченной ответственностью (ООО);</li><li>Акционерное общество (АО), Крестьянско-фермерское хозяйство и Сельскохозяйственный потребительский/производственный кооператив (за исключением кредитных кооперативов) при условии регистрации в качестве юридического лица</li></ul>',
  },
  benefits: {
    description: {
      differentDepositVariants: 'Доступны разные <br/>варианты залога',
      comfortableRepaymentSchedule: 'Удобный график <br/>погашений',
      optimalDeadline: 'Оптимальные сроки <br/>кредитования',
    },
  },
  conditions: { title: 'Условия кредитования' },
  breadcrumb: 'Инвестиционный кредит',
  landingConditionsTable: {
    text: {
      innerHeading: {
        investment: 'Инвестиционный',
        rules: 'Линейка «Урожайный бизнес»',
      },
    },
  },
  forAgrariansOnly: 'Доступно только для аграриев',
  simpleRequest: 'Простая подача <br/>заявки',
  details: {
    value: {
      untilFifeHundredMillions: "до <span class='h2 h3-sm with-counter-animation' data-value='500'>0</span> млн ₽",
      fromOnePercent: "от <span class='h2 h3-sm with-counter-animation' data-value='1'>0%</span>",
      untilFifteenYears: "до <span class='h2 h3-sm with-counter-animation' data-value='12'>0</span> лет",
    },
    sign: {
      creditSize: 'размер кредита',
      preferentialRate: 'льготная ставка',
      deadline: 'срок кредитования',
    },
  },
} satisfies TMessages
